import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { ConfigService } from '../../../config/config.service';
import { Client } from '../../shared/client/client';
import { Dav } from './dav';
import { Site } from './site';

@Injectable({
  providedIn: 'root'
})
export class DavService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  public getSites(): Observable<Array<Site>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Site>>(config.apiPoint + config.getSites);
      })
    );
  }

  public getClients(site: Site, nameFilter: string): Observable<Array<Client>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Client>>(config.apiPoint + config.getClients, {
          params: {
            "siteFilter": site.numero,
          }
        });
      })
    );
  }

  public saveDav(dav: Dav) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        if (dav.id != null) {
          return this.http.put<Dav>(config.apiPoint + config.getDav.replace('{dav}', dav.id),
            this.prepareUserData(dav)
          );
        } else {
          return this.http.post<Dav>(config.apiPoint + config.getDavs,
            this.prepareUserData(dav)
          );
        }
      })
    );
  }

  private prepareUserData(dav: Dav) {
    return {
      adresse_serveur: dav.adresse_serveur,
      login: dav.login,
      password: dav.password,
      nom: dav.nom,
      partenaire: dav.partenaire,
      clients: dav.clients.map(client => client.id),
      site: dav.site != null ? dav.site.id : null
    };
  }

  public getDavs(nameFilter: string = ""): Observable<Array<Dav>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Dav>>(config.apiPoint + config.getDavs, {
          params: {
            nameFilter: nameFilter
          }
        });
      })
    );
  };

  public getProfileOfDav(davId: string): Observable<Dav> {
    return this.configService.getConfig().pipe(
      mergeMap(conf => {
        return this.http.get<Dav>(
          conf.apiPoint + conf.getDav.replace("{dav}", davId)
        );
      })
    );
  }

  public getKey(): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap(conf => {
        return this.http.get<any>(conf.apiPoint + conf.getDavKey);
      })
    );
  }

  public downloadMajDav(client: string, dav: string, again: boolean) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.getDownloadDavMaj.replace("{client}", client), { params: { reDownload: again } }).pipe(
          tap(res => {
            let blob = new Blob([res['file']], { type: 'application/octet-stream' });
            let filename = `${dav}_${res['filename']}`;
            const nav = (window.navigator as any);
            if (nav.msSaveOrOpenBlob) {
              let newUrl = nav.msSaveOrOpenBlob(blob, filename);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          })
        );
      })
    );
  }

  public downloadPuces(client: string) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.getDownloadDavPuces.replace("{client}", client)).pipe(
          tap(res => {
            let blob = new Blob([res.toString()], { type: 'application/octet-stream' });
            let filename = `${client}_BASECOMPLETE.txt`;
            const nav = (window.navigator as any);
            if (nav.msSaveOrOpenBlob) {
              let newUrl = nav.msSaveOrOpenBlob(blob, filename);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          })
        );
      })
    );
  }
}
